import { useState, useEffect } from 'react'
import { iMsg, iSubm } from '../types/msg.types'

export interface iExtContractOut {
  systemExtId: string
  objectExtId: string
  slug?: string
}

interface iExtContractIn {
  externalSystemUrl: string
  externalIdentifier: string
}

type iFetchFce = (extContracts: iExtContractIn[]) => Promise<any>
let fetchFce: iFetchFce | undefined

export const registerFetchFce = (newFetchFce: iFetchFce) => {
  fetchFce = newFetchFce
}

//TODO cachovat do global promenne???

export const useContractsSlug = (msgs: (iMsg | iSubm)[]) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [data, setData] = useState<iExtContractOut[]>()

  const fetchData = async () => {
    setError('')
    setLoading(true)

    const extContracts = msgs
      .filter(m => m.systemExtId && m.objectExtId)
      .map(m => ({
        externalSystemUrl: m.systemExtId,
        externalIdentifier: m.objectExtId
      }))

    try {
      if (extContracts.length && fetchFce) {
        const result = await fetchFce(extContracts)
        const resData = result.map((r: any) => ({
          systemExtId: r.externalSystem?.url,
          objectExtId: r.externalIdentifier,
          slug: r.slug
        }))
        setData(resData)
      } else {
        setData([])
      }
    } catch (error: any) {
      setError(error.toString())
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (msgs.length && fetchFce) {
      fetchData()
    }
  }, [msgs])


  return { loading, error, data }
}
